<template>
  <span class="common_arrow" :class="{ 'btn': isButton }" :style="{ width: `${width}px`, height: `${height}px` }" />
</template>

<script>
export default {
  name: 'IconClose',

  props: {
    width: {
      type: Number,
      default: 11
    },

    height: {
      type: Number,
      default: 16
    },

    isButton: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .common_arrow { display: inline-block; background-image: url(~@/assets/images/icon_arrow.png); background-size: cover;
    &.btn { cursor: pointer;
      &:hover { background-image: url(~@/assets/images/icon_arrow_hover.png); }
      &:active { background-image: url(~@/assets/images/icon_arrow_active.png); }
    }
  }
</style>
